const classPreKG = ['Select Class', 'Kindergarten I', 'Kindergarten II', 'Pre-KG' ];
const classGrade11 = ['Select Class', 'Grade 11', 'Grade 12'];
const class1to10 = [
  'Select Class',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Grade 9',
  'Grade 10',
];
const classMont = ['Select Class', 'Montessori I', 'Montessori II', 'Montessori III' ];

const findClass = (sectionData) => {
  if (sectionData === '1to9') {
    return class1to10;
  } else if (sectionData === 'prekg') {
    return classPreKG;
  } else if (sectionData === 'mont') {
    return classMont;
  } else if (sectionData === '11') {
    return classGrade11;
  }
};

export default findClass;
